import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ConsultationBadge } from '../specialist/ConsultationBadge';
import { PRANIC_PATH, PRANIC_CARD_IMAGE, PRANIC_INTRO } from '../../lib/specialist/pranicHealing';
import '../specialist/specialist.css';

const SpecialistServicesSection = () => (
  <section id="specialist-services" className="section-padding" data-testid="specialist-services-section">
    <div className="container">
      <div style={{ maxWidth: 640, marginBottom: '3rem' }}>
        <p className="sp-eyebrow">Specialist Services</p>
        <h2 className="section-title" style={{ textAlign: 'left', marginTop: '0.75rem' }}>
          Complementary practices, by consultation
        </h2>
        <p className="section-subtitle" style={{ textAlign: 'left', marginLeft: 0 }}>
          Optional, specialist offerings that sit alongside your evidence-based ZEEVA program.
        </p>
      </div>

      <Link to={PRANIC_PATH} className="sp-home-card" data-testid="specialist-card-pranic-healing" style={{ textDecoration: 'none' }}>
        <div className="sp-home-media">
          <img src={PRANIC_CARD_IMAGE} alt="Person in a calm meditative posture" loading="lazy" decoding="async" />
        </div>
        <div className="sp-home-body">
          <p className="sp-eyebrow" style={{ color: 'var(--brand-primary)' }}>Complementary Practice</p>
          <h3 className="sp-h2" style={{ marginTop: 0 }}>{PRANIC_INTRO.title}</h3>
          <p className="sp-body">{PRANIC_INTRO.lead}</p>
          <div><ConsultationBadge testId="specialist-card-consultation-badge" /></div>
          <span className="network-nav-link" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: 'var(--brand-accent)', padding: 0 }} data-testid="specialist-card-learn-more">
            Explore &amp; Enquire <ArrowRight size={16} aria-hidden="true" />
          </span>
        </div>
      </Link>
    </div>
  </section>
);

export default SpecialistServicesSection;
